// 액션 타입 정의
const EDIT_TITLE1 = 'EDIT_TITLE1';
const EDIT_SUBTITLE1 = 'EDIT_SUBTITLE1';
const EDIT_FONTSIZE1 = 'EDIT_FONTSIZE1';
const EDIT_SUBFONTSIZE = 'EDIT_SUBFONTSIZE';
const EDIT_FONTWEIGHT1 = 'EDIT_FONTWEIGHT1';
const EDIT_SUBFONTWEIGHT = 'EDIT_SUBFONTWEIGHT';
const EDIT_TEXTCOLOR = 'EDIT_TEXTCOLOR';
const EDIT_SUBTEXTCOLOR = 'EDIT_SUBTEXTCOLOR';
const EDIT_YEAR = 'EDIT_YEAR';
const EDIT_FULL_COUNTDOWN_TITLE = 'EDIT_FULL_COUNTDOWN_TITLE';
const EDIT_FULL_COUNTDOWN_SUBTITLE = 'EDIT_FULL_COUNTDOWN_SUBTITLE';
const EDIT_FULLCOUNTDOWN_TEXTCOLOR = 'EDIT_FULLCOUNTDOWN_TEXTCOLOR';
const EDIT_FULL_COUNTDOWN_CLOSING = 'EDIT_FULL_COUNTDOWN_CLOSING';
const EDIT_FULL_COUNTDOWN_CLOSING_FONTWEIGHT =
  'EDIT_FULL_COUNTDOWN_CLOSING_FONTWEIGHT';
const EDIT_FULL_COUNTDOWN_CLOSING_FONTCOLOR =
  'EDIT_FULL_COUNTDOWN_CLOSING_FONTCOLOR';
const EDIT_FULL_COUNTDOWN_CLOSING_FONTSIZE =
  'EDIT_FULL_COUNTDOWN_CLOSING_FONTSIZE';
const EDIT_COUNTDOWN_TIMER_TEXT = 'EDIT_COUNTDOWN_TIMER_TEXT';
const EDIT_COUNTDOWN_TIMER_FONTWEIGHT = 'EDIT_COUNTDOWN_TIMER_FONTWEIGHT';
const EDIT_TIMER_COLOR = 'EDIT_TIMER_COLOR';
const EDIT_HALF_TOP_FONTSIZE = 'EDIT_HALF_TOP_FONTSIZE';
const EDIT_HALF_TOP_FONTWEIGHT = 'EDIT_HALF_TOP_FONTWEIGHT';
const EDIT_HALF_TOP_TITLE = 'EDIT_HALF_TOP_TITLE';
const EDIT_HALF_TOP_TEXTCOLOR = 'EDIT_HALF_TOP_TEXTCOLOR';
const EDIT_FULLCOUNTDOWN_TITLE_FONTSIZE = 'EDIT_FULLCOUNTDOWN_TITLE_FONTSIZE';
const EDIT_HALF_TOP_SUB_FONTSIZE = 'EDIT_HALF_TOP_SUB_FONTSIZE';
const EDIT_MODAL_TITLE = 'EDIT_MODAL_TITLE';
const EDIT_MODAL_TEXT_COLOR = 'EDIT_MODAL_TEXT_COLOR';
const EDIT_MODAL_FONT_WEIGHT = 'EDIT_MODAL_FONT_WEIGHT';
const EDIT_MODAL_FONT_SIZE = 'EDIT_MODAL_FONT_SIZE';
const EDIT_HALF_TOP_SUB_TITLE = 'EDIT_HALF_TOP_SUB_TITLE';
const EDIT_HALF_TOP_SUB_FONT_COLOR = 'EDIT_HALF_TOP_SUB_FONT_COLOR';
const EDIT_HALF_TOP_SUB_FONT_WEIGHT = 'EDIT_HALF_TOP_SUB_FONT_WEIGHT';
const EDIT_MODAL_PAGING_TIMER_TEXT = 'EDIT_MODAL_PAGING_TIMER_TEXT';
const EDIT_MODAL_PAGING_TIMER_COLOR = 'EDIT_MODAL_PAGING_TIMER_COLOR';
const EDIT_MODAL_PAGING_TIMER_FONT_WEIGHT =
  'EDIT_MODAL_PAGING_TIMER_FONT_WEIGHT';
const EDIT_FULL_DUAL_TITLE = 'EDIT_FULL_DUAL_TITLE';
const EDIT_FULL_DUAL_SUBTITLE = 'EDIT_FULL_DUAL_SUBTITLE';
const EDIT_TEXT_RESET = 'EDIT_TEXT_RESET';
const EDIT_FULL_DUAL_CONTENT1 = 'EDIT_FULL_DUAL_CONTENT1';
const EDIT_FULL_DUAL_CONTENT2 = 'EDIT_FULL_DUAL_CONTENT2';
const EDIT_FULL_DUAL_SUBCONTENT1 = 'EDIT_FULL_DUAL_SUBCONTENT1';
const EDIT_FULL_DUAL_SUBCONTENT2 = 'EDIT_FULL_DUAL_SUBCONTENT2';
const EDIT_FULL_DUAL_TITLE_COLOR = 'EDIT_FULL_DUAL_TITLE_COLOR';
const EDIT_FULL_DUAL_SUBTITLE_COLOR = 'EDIT_FULL_DUAL_SUBTITLE_COLOR';
const EDIT_FULL_DUAL_CONTENT1_COLOR = 'EDIT_FULL_DUAL_CONTENT1_COLOR';
const EDIT_FULL_DUAL_CONTENT2_COLOR = 'EDIT_FULL_DUAL_CONTENT2_COLOR';
const EDIT_FULL_DUAL_TITLE_FONTSIZE = 'EDIT_FULL_DUAL_TITLE_FONTSIZE';
const EDIT_FULL_DUAL_SUBTITLE_FONTSIZE = 'EDIT_FULL_DUAL_SUBTITLE_FONTSIZE';
const EDIT_FULL_DUAL_CONTENT1_FONTSIZE = 'EDIT_FULL_DUAL_CONTENT1_FONTSIZE';
const EDIT_FULL_DUAL_CONTENT2_FONTSIZE = 'EDIT_FULL_DUAL_CONTENT2_FONTSIZE';
const EDIT_FULL_DUAL_TITLE_FONT_WEIGHT = 'EDIT_FULL_DUAL_TITLE_FONT_WEIGHT';
const EDIT_FULL_DUAL_SUBTITLE_FONT_WEIGHT =
  'EDIT_FULL_DUAL_SUBTITLE_FONT_WEIGHT';
const EDIT_FULL_DUAL_CONTENT1_FONT_WEIGHT =
  'EDIT_FULL_DUAL_CONTENT1_FONT_WEIGHT';
const EDIT_FULL_DUAL_CONTENT2_FONT_WEIGHT =
  'EDIT_FULL_DUAL_CONTENT2_FONT_WEIGHT';
const EDIT_MODAL_SLICK_TITLE = 'EDIT_MODAL_SLICK_TITLE';
const EDIT_MODAL_SLICK_SUBTITLE = 'EDIT_MODAL_SLICK_SUBTITLE';
const EDIT_MODAL_SLICK_TITLE_COLOR = 'EDIT_MODAL_SLICK_TITLE_COLOR';
const EDIT_MODAL_SLICK_SUBTITLE_COLOR = 'EDIT_MODAL_SLICK_SUBTITLE_COLOR';
const EDIT_MODAL_SLICK_TITLE_FONT_WEIGHT = 'EDIT_MODAL_SLICK_TITLE_FONT_WEIGHT';
const EDIT_MODAL_SLICK_SUBTITLE_FONT_WEIGHT =
  'EDIT_MODAL_SLICK_SUBTITLE_FONT_WEIGHT';
const EDIT_MODAL_SLICK_TITLE_FONTSIZE = 'EDIT_MODAL_SLICK_TITLE_FONTSIZE';
const EDIT_MODAL_SLICK_SUBTITLE_FONTSIZE = 'EDIT_MODAL_SLICK_SUBTITLE_FONTSIZE';
const EDIT_FULL_SURVEY_TITLE = 'EDIT_FULL_SURVEY_TITLE';
const EDIT_FULL_SURVEY_SUBTITLE = 'EDIT_FULL_SURVEY_SUBTITLE';
const EDIT_FULL_SURVEY_TITLE_COLOR = 'EDIT_FULL_SURVEY_TITLE_COLOR';
const EDIT_FULL_SURVEY_SUBTITLE_COLOR = 'EDIT_FULL_SURVEY_SUBTITLE_COLOR';
const EDIT_FULL_SURVEY_TITLE_FONT_WEIGHT = 'EDIT_FULL_SURVEY_TITLE_FONT_WEIGHT';
const EDIT_FULL_SURVEY_SUBTITLE_FONT_WEIGHT =
  'EDIT_FULL_SURVEY_SUBTITLE_FONT_WEIGHT';
const EDIT_FULL_SURVEY_TITLE_FONTSIZE = 'EDIT_FULL_SURVEY_TITLE_FONTSIZE';
const EDIT_FULL_SURVEY_SUBTITLE_FONTSIZE = 'EDIT_FULL_SURVEY_SUBTITLE_FONTSIZE';
const EDIT_MODAL_TOP_TITLE = 'EDIT_MODAL_TOP_TITLE';
const EDIT_MODAL_TOP_TITLE_FONTWEIGHT = 'EDIT_MODAL_TOP_TITLE_FONTWEIGHT';
const EDIT_MODAL_TOP_TITLE_COLOR = 'EDIT_MODAL_TOP_TITLE_COLOR';
const EDIT_MODAL_TOP_TITLE_FONTSIZE = 'EDIT_MODAL_TOP_TITLE_FONTSIZE';
const EDIT_SINGLE_MODAL_TOP_TITLE = 'EDIT_SINGLE_MODAL_TOP_TITLE';
const EDIT_SINGLE_MODAL_TOP_TITLE_FONTWEIGHT =
  'EDIT_SINGLE_MODAL_TOP_TITLE_FONTWEIGHT';
const EDIT_SINGLE_MODAL_TOP_TITLE_COLOR = 'EDIT_SINGLE_MODAL_TOP_TITLE_COLOR';
const EDIT_SINGLE_MODAL_TOP_TITLE_FONTSIZE =
  'EDIT_SINGLE_MODAL_TOP_TITLE_FONTSIZE';
const EDIT_HALF_SLIDE_UP_TITLE = 'EDIT_HALF_SLIDE_UP_TITLE';
const EDIT_HALF_SLIDE_UP_TITLE_FONTWEIGHT =
  'EDIT_HALF_SLIDE_UP_TITLE_FONTWEIGHT';
const EDIT_HALF_SLIDE_UP_TITLE_COLOR = 'EDIT_HALF_SLIDE_UP_TITLE_COLOR';
const EDIT_HALF_SLIDE_UP_TITLE_FONTSIZE = 'EDIT_HALF_SLIDE_UP_TITLE_FONTSIZE';
const EDIT_HALF_SLIDE_UP_SUBTITLE = 'EDIT_HALF_SLIDE_UP_SUBTITLE';
const EDIT_HALF_SLIDE_UP_SUBTITLE_FONTWEIGHT =
  'EDIT_HALF_SLIDE_UP_SUBTITLE_FONTWEIGHT';
const EDIT_HALF_SLIDE_UP_SUBTITLE_COLOR = 'EDIT_HALF_SLIDE_UP_SUBTITLE_COLOR';
const EDIT_HALF_SLIDE_UP_SUBTITLE_FONTSIZE =
  'EDIT_HALF_SLIDE_UP_SUBTITLE_FONTSIZE';
const EDIT_HALF_SLIDE_UP_IMGS_TITLE = 'EDIT_HALF_SLIDE_UP_IMGS_TITLE';
const EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTWEIGHT =
  'EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTWEIGHT';
const EDIT_HALF_SLIDE_UP_IMGS_TITLE_COLOR =
  'EDIT_HALF_SLIDE_UP_IMGS_TITLE_COLOR';
const EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTSIZE =
  'EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTSIZE';
const EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE = 'EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE';
const EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTWEIGHT =
  'EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTWEIGHT';
const EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_COLOR =
  'EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_COLOR';
const EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTSIZE =
  'EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTSIZE';

const NPS_MODAL_DIAL_TITLE_TEXT = 'NPS_MODAL_DIAL_TITLE_TEXT';
const NPS_MODAL_DIAL_TITLE_FONTSIZE = 'NPS_MODAL_DIAL_TITLE_FONTSIZE';
const NPS_MODAL_DIAL_TITLE_FONTWEIGHT = 'NPS_MODAL_DIAL_TITLE_WEIGHT';
const NPS_MODAL_DIAL_TITLE_TEXT_COLOR = 'NPS_MODAL_DIAL_TITLE_TEXT_COLOR';

const NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT = 'NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT';
const NPS_MODAL_RECT_DIAL_SUBTITLE_FONTSIZE =
  'NPS_MODAL_RECT_DIAL_SUBTITLE_FONTSIZE';
const NPS_MODAL_RECT_DIAL_SUBTITLE_FONTWEIGHT =
  'NPS_MODAL_RECT_DIAL_SUBTITLE_WEIGHT';
const NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT_COLOR =
  'NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT_COLOR';

const EDIT_TITLE = 'EDIT_TITLE';
const EDIT_SUB_TITLE = 'EDIT_SUB_TITLE';
const EDIT_CONTENTS = 'EDIT_CONTENTS';

const TEXT = 'TEXT';
const PRE_FONT_SIZE = 'PRE_FONT_SIZE';
const FONT_SIZE = 'FONT_SIZE';
const FONT_WEIGHT = 'FONT_WEIGHT';
const COLOR = 'COLOR';
const FONT_FAMILY = 'FONT_FAMILY';
const TEXT_ALIGN = 'TEXT_ALIGN';

// 액션 생섬함수 정의
export const editTextReset = () => ({ type: EDIT_TEXT_RESET });
export const editTitle1 = text => ({ type: EDIT_TITLE1, text });
export const editSubtitle = subText => ({
  type: EDIT_SUBTITLE1,
  subText
});
export const editFontSize1 = (fontSize, previewFontSize) => ({
  type: EDIT_FONTSIZE1,
  fontSize,
  previewFontSize
});
export const editFullCountdownFontSize = (
  yearFontSize,
  titleFontSize,
  previewYearFontSize,
  previewTitleFontSize
) => ({
  type: EDIT_FULLCOUNTDOWN_TITLE_FONTSIZE,
  yearFontSize,
  titleFontSize,
  previewYearFontSize,
  previewTitleFontSize
});
export const editSubFontSize = (subFontSize, previewSubFontSize) => ({
  type: EDIT_SUBFONTSIZE,
  subFontSize,
  previewSubFontSize
});
export const editFontWeight1 = fontWeight => ({
  type: EDIT_FONTWEIGHT1,
  fontWeight
});
export const editSubFontWeight = subFontWeight => ({
  type: EDIT_SUBFONTWEIGHT,
  subFontWeight
});
export const editfullCountdownFontWeight = (
  titleFontWeight,
  yearFontWeight
) => ({
  type: EDIT_FONTWEIGHT1,
  titleFontWeight,
  yearFontWeight
});
export const editTextColor = textColor => ({ type: EDIT_TEXTCOLOR, textColor });
export const editSubTextColor = subTextColor => ({
  type: EDIT_SUBTEXTCOLOR,
  subTextColor
});
export const editfullCountdownTextColor = fullCountdownTextColor => ({
  type: EDIT_FULLCOUNTDOWN_TEXTCOLOR,
  fullCountdownTextColor
});
export const editfullCountdownSubTitleColor = fullCountdownSubTitleColor => ({
  type: EDIT_TEXTCOLOR,
  fullCountdownSubTitleColor
});
export const editYear = titleYear => ({ type: EDIT_YEAR, titleYear });
export const editfullCountdownTitle = titleText => ({
  type: EDIT_FULL_COUNTDOWN_TITLE,
  titleText
});
export const editfullConutdownSubTitle = subTitle => ({
  type: EDIT_FULL_COUNTDOWN_SUBTITLE,
  subTitle
});
export const editfullCountdownSubFontWeight = subTitleFontWeight => ({
  type: EDIT_SUBFONTWEIGHT,
  subTitleFontWeight
});

export const editTimerFontWeight = timerFontWeight => ({
  type: EDIT_COUNTDOWN_TIMER_FONTWEIGHT,
  timerFontWeight
});

export const editfullCountdownSubTitleFontSize = (
  subTitleFontSize,
  previewSubTitleFontSize
) => ({
  type: EDIT_SUBFONTSIZE,
  subTitleFontSize,
  previewSubTitleFontSize
});

export const editfullCountdownTimerText = countdownTimerText => ({
  type: EDIT_COUNTDOWN_TIMER_TEXT,
  countdownTimerText
});

export const editfullCountdownClosing = countdownClosing => ({
  type: EDIT_FULL_COUNTDOWN_CLOSING,
  countdownClosing
});

export const editfullCountdownClosingFontWeight = countdownClosingFontWeight => ({
  type: EDIT_FULL_COUNTDOWN_CLOSING_FONTWEIGHT,
  countdownClosingFontWeight
});

export const editfullCountdownClosingFontColor = countdownClosingFontColor => ({
  type: EDIT_FULL_COUNTDOWN_CLOSING_FONTCOLOR,
  countdownClosingFontColor
});

export const editfullCountdownClosingFontSize = (
  fullCountDownClosingFontSize,
  previewFullCountDownClosingFontSize
) => ({
  type: EDIT_FULL_COUNTDOWN_CLOSING_FONTSIZE,
  fullCountDownClosingFontSize,
  previewFullCountDownClosingFontSize
});

export const editModalPagingTimerText = modalPagingTimerText => ({
  type: EDIT_MODAL_PAGING_TIMER_TEXT,
  modalPagingTimerText
});

export const editTimerColor = countdownTimerColor => ({
  type: EDIT_TIMER_COLOR,
  countdownTimerColor
});
export const editHalfTopImageTitle = halfTopImageText => ({
  type: EDIT_HALF_TOP_TITLE,
  halfTopImageText
});
export const editHalfTopFontSize = (
  halfTopFontSize,
  previewHalfTopFontSize
) => ({
  type: EDIT_HALF_TOP_FONTSIZE,
  halfTopFontSize,
  previewHalfTopFontSize
});

export const editHalfTopSubTitle = halfTopImageSubText => ({
  type: EDIT_HALF_TOP_SUB_TITLE,
  halfTopImageSubText
});

export const editHalfTopSubFontColor = halfTopSubFontColor => ({
  type: EDIT_HALF_TOP_SUB_FONT_COLOR,
  halfTopSubFontColor
});

export const editHalfTopSubFontSize = (
  halfTopSubFontSize,
  previewHalfTopSubFontSize
) => ({
  type: EDIT_HALF_TOP_SUB_FONTSIZE,
  halfTopSubFontSize,
  previewHalfTopSubFontSize
});

export const editHalfTopFontWeight = halfTopFontWeight => ({
  type: EDIT_HALF_TOP_FONTWEIGHT,
  halfTopFontWeight
});
export const editHalfTopTextColor = halfTopTextColor => ({
  type: EDIT_HALF_TOP_TEXTCOLOR,
  halfTopTextColor
});
export const editHalfTopSubFontWeight = halfTopSubFontWeight => ({
  type: EDIT_HALF_TOP_SUB_FONT_WEIGHT,
  halfTopSubFontWeight
});

export const editModalPagingTitle = modalPagingTitle => ({
  type: EDIT_MODAL_TITLE,
  modalPagingTitle
});

export const editModalPagingTextColor = modalPagingTextColor => ({
  type: EDIT_MODAL_TEXT_COLOR,
  modalPagingTextColor
});

export const editModalPagingFontWeight = modalPagingTextFontWeight => ({
  type: EDIT_MODAL_FONT_WEIGHT,
  modalPagingTextFontWeight
});

export const editModalPagingFontSize = (
  modalPagingFontSize,
  previewModalPagingFontSize
) => ({
  type: EDIT_MODAL_FONT_SIZE,
  modalPagingFontSize,
  previewModalPagingFontSize
});

export const editModalPagingTimerColor = modalPagingTimerColor => ({
  type: EDIT_MODAL_PAGING_TIMER_COLOR,
  modalPagingTimerColor
});

export const editModalPagingTimerFontWeight = modalPagingTimerFontWeight => ({
  type: EDIT_MODAL_PAGING_TIMER_FONT_WEIGHT,
  modalPagingTimerFontWeight
});
export const editFullDualTitle = fullDualTitle => ({
  type: EDIT_FULL_DUAL_TITLE,
  fullDualTitle
});
export const editFullDualSubTitle = fullDualSubTitle => ({
  type: EDIT_FULL_DUAL_SUBTITLE,
  fullDualSubTitle
});
export const editFullDualContent1 = fullDualContent1 => ({
  type: EDIT_FULL_DUAL_CONTENT1,
  fullDualContent1
});
export const editFullDualContent2 = fullDualContent2 => ({
  type: EDIT_FULL_DUAL_CONTENT2,
  fullDualContent2
});
export const editFullDualSubContent1 = fullDualSubContent1 => ({
  type: EDIT_FULL_DUAL_SUBCONTENT1,
  fullDualSubContent1
});
export const editFullDualSubContent2 = fullDualSubContent2 => ({
  type: EDIT_FULL_DUAL_SUBCONTENT2,
  fullDualSubContent2
});
export const editFulldualTitleColor = fullDualTitleColor => ({
  type: EDIT_FULL_DUAL_TITLE_COLOR,
  fullDualTitleColor
});
export const editFulldualSubTitleColor = fullDualSubTitleColor => ({
  type: EDIT_FULL_DUAL_SUBTITLE_COLOR,
  fullDualSubTitleColor
});
export const editFulldualContent1Color = fullDualContent1Color => ({
  type: EDIT_FULL_DUAL_CONTENT1_COLOR,
  fullDualContent1Color
});
export const editFulldualContent2Color = fullDualContent2Color => ({
  type: EDIT_FULL_DUAL_CONTENT2_COLOR,
  fullDualContent2Color
});
export const editFulldualTitleFontSize = (
  fullDualTitleFontSize,
  previewFullDualTitleFontSize
) => ({
  type: EDIT_FULL_DUAL_TITLE_FONTSIZE,
  fullDualTitleFontSize,
  previewFullDualTitleFontSize
});
export const editFulldualSubTitleFontSize = (
  fullDualSubTitleFontSize,
  previewFullDualSubTitleFontSize
) => ({
  type: EDIT_FULL_DUAL_SUBTITLE_FONTSIZE,
  fullDualSubTitleFontSize,
  previewFullDualSubTitleFontSize
});
export const editFulldualContent1FontSize = (
  fullDualContent1FontSize,
  previewFullDualContent1FontSize
) => ({
  type: EDIT_FULL_DUAL_CONTENT1_FONTSIZE,
  fullDualContent1FontSize,
  previewFullDualContent1FontSize
});
export const editFulldualContent2FontSize = (
  fullDualContent2FontSize,
  previewFullDualContent2FontSize
) => ({
  type: EDIT_FULL_DUAL_CONTENT2_FONTSIZE,
  fullDualContent2FontSize,
  previewFullDualContent2FontSize
});
export const editFulldualTitleFontWeight = fullDualTitleFontWeight => ({
  type: EDIT_FULL_DUAL_TITLE_FONT_WEIGHT,
  fullDualTitleFontWeight
});
export const editFulldualSubTitleFontWeight = fullDualSubTitleFontWeight => ({
  type: EDIT_FULL_DUAL_SUBTITLE_FONT_WEIGHT,
  fullDualSubTitleFontWeight
});
export const editFulldualContent1FontWeight = fullDualContent1FontWeight => ({
  type: EDIT_FULL_DUAL_CONTENT1_FONT_WEIGHT,
  fullDualContent1FontWeight
});
export const editFulldualContent2FontWeight = fullDualContent2FontWeight => ({
  type: EDIT_FULL_DUAL_CONTENT2_FONT_WEIGHT,
  fullDualContent2FontWeight
});
export const editModalSlickTitle = modalSlickTitle => ({
  type: EDIT_MODAL_SLICK_TITLE,
  modalSlickTitle
});
export const editModalSlickSubTitle = modalSlickSubTitle => ({
  type: EDIT_MODAL_SLICK_SUBTITLE,
  modalSlickSubTitle
});
export const editModalSlickTitleColor = modalSlickTitleColor => ({
  type: EDIT_MODAL_SLICK_TITLE_COLOR,
  modalSlickTitleColor
});
export const editModalSlickSubTitleColor = modalSlickSubTitleColor => ({
  type: EDIT_MODAL_SLICK_SUBTITLE_COLOR,
  modalSlickSubTitleColor
});
export const editModalSlickTitleFontWeight = modalSlickTitleFontWeight => ({
  type: EDIT_MODAL_SLICK_TITLE_FONT_WEIGHT,
  modalSlickTitleFontWeight
});
export const editModalSlickSubTitleFontWeight = modalSlickSubTitleFontWeight => ({
  type: EDIT_MODAL_SLICK_SUBTITLE_FONT_WEIGHT,
  modalSlickSubTitleFontWeight
});
export const editModalSlickTitleFontSize = (
  modalSlickTitleFontSize,
  previewModalSlickTitleFontSize
) => ({
  type: EDIT_MODAL_SLICK_TITLE_FONTSIZE,
  modalSlickTitleFontSize,
  previewModalSlickTitleFontSize
});
export const editModalSlickSubTitleFontSize = (
  modalSlickSubTitleFontSize,
  previewModalSlickSubTitleFontSize
) => ({
  type: EDIT_MODAL_SLICK_SUBTITLE_FONTSIZE,
  modalSlickSubTitleFontSize,
  previewModalSlickSubTitleFontSize
});
export const editFullSurveyTitle = fullSurveyTitle => ({
  type: EDIT_FULL_SURVEY_TITLE,
  fullSurveyTitle
});
export const editFullSurveySubTitle = fullSurveySubTitle => ({
  type: EDIT_FULL_SURVEY_SUBTITLE,
  fullSurveySubTitle
});
export const editFullSurveyTitleColor = fullSurveyTitleColor => ({
  type: EDIT_FULL_SURVEY_TITLE_COLOR,
  fullSurveyTitleColor
});
export const editFullSurveySubTitleColor = fullSurveySubTitleColor => ({
  type: EDIT_FULL_SURVEY_SUBTITLE_COLOR,
  fullSurveySubTitleColor
});
export const editFullSurveyTitleFontWeight = fullSurveyTitleFontWeight => ({
  type: EDIT_FULL_SURVEY_TITLE_FONT_WEIGHT,
  fullSurveyTitleFontWeight
});
export const editFullSurveySubTitleFontWeight = fullSurveySubTitleFontWeight => ({
  type: EDIT_FULL_SURVEY_SUBTITLE_FONT_WEIGHT,
  fullSurveySubTitleFontWeight
});
export const editFullSurveyTitlFontSize = (
  fullSurveyTitleFontSize,
  previewFullSurveyTitleFontSize
) => ({
  type: EDIT_FULL_SURVEY_TITLE_FONTSIZE,
  fullSurveyTitleFontSize,
  previewFullSurveyTitleFontSize
});
export const editFullSurveySubTitleFontSize = (
  fullSurveySubTitleFontSize,
  previewFullSurveySubTitleFontSize
) => ({
  type: EDIT_FULL_SURVEY_SUBTITLE_FONTSIZE,
  fullSurveySubTitleFontSize,
  previewFullSurveySubTitleFontSize
});
export const editModalTopTitle = modalTopImageText => ({
  type: EDIT_MODAL_TOP_TITLE,
  modalTopImageText
});
export const editModalTopTitleFontWeight = modalTopImageTextFontWeight => ({
  type: EDIT_MODAL_TOP_TITLE_FONTWEIGHT,
  modalTopImageTextFontWeight
});
export const editModalTopTitleColor = modalTopImageTextColor => ({
  type: EDIT_MODAL_TOP_TITLE_COLOR,
  modalTopImageTextColor
});
export const editModalTopTitleFontSize = (
  modalTopImageTextFontSize,
  previewModalTopImageTextFontSize
) => ({
  type: EDIT_MODAL_TOP_TITLE_FONTSIZE,
  modalTopImageTextFontSize,
  previewModalTopImageTextFontSize
});
export const editSingleModalTopTitle = singleModalTopText => ({
  type: EDIT_SINGLE_MODAL_TOP_TITLE,
  singleModalTopText
});
export const editSingleModalTopTitleFontWeight = singleModalTopTextFontWeight => ({
  type: EDIT_SINGLE_MODAL_TOP_TITLE_FONTWEIGHT,
  singleModalTopTextFontWeight
});
export const editSingleModalTopTitleColor = singleModalTopTextColor => ({
  type: EDIT_SINGLE_MODAL_TOP_TITLE_COLOR,
  singleModalTopTextColor
});
export const editSingleModalTopTitleFontSize = (
  singleModalTopTextFontSize,
  previewSingleModalTopTextFontSize
) => ({
  type: EDIT_SINGLE_MODAL_TOP_TITLE_FONTSIZE,
  singleModalTopTextFontSize,
  previewSingleModalTopTextFontSize
});
export const editHalfSlideUpSubTitle = halfSlideUpSubTitle => ({
  type: EDIT_HALF_SLIDE_UP_SUBTITLE,
  halfSlideUpSubTitle
});
export const editHalfSlideUpSubTitleFontWeight = halfSlideUpSubTitleFontWeight => ({
  type: EDIT_HALF_SLIDE_UP_SUBTITLE_FONTWEIGHT,
  halfSlideUpSubTitleFontWeight
});
export const editHalfSlideUpSubTitleColor = halfSlideUpSubTitleColor => ({
  type: EDIT_HALF_SLIDE_UP_SUBTITLE_COLOR,
  halfSlideUpSubTitleColor
});
export const editHalfSlideUpSubTitleFontSize = (
  halfSlideUpSubTitleFontSize,
  previewHalfSlideUpSubTitleFontSize
) => ({
  type: EDIT_HALF_SLIDE_UP_SUBTITLE_FONTSIZE,
  halfSlideUpSubTitleFontSize,
  previewHalfSlideUpSubTitleFontSize
});
export const editHalfSlideUpTitle = halfSlideUpTitle => ({
  type: EDIT_HALF_SLIDE_UP_TITLE,
  halfSlideUpTitle
});
export const editHalfSlideUpTitleFontWeight = halfSlideUpTitleFontWeight => ({
  type: EDIT_HALF_SLIDE_UP_TITLE_FONTWEIGHT,
  halfSlideUpTitleFontWeight
});
export const editHalfSlideUpTitleColor = halfSlideUpTitleColor => ({
  type: EDIT_HALF_SLIDE_UP_TITLE_COLOR,
  halfSlideUpTitleColor
});
export const editHalfSlideUpTitleFontSize = (
  halfSlideUpTitleFontSize,
  previewHalfSlideUpTitleFontSize
) => ({
  type: EDIT_HALF_SLIDE_UP_TITLE_FONTSIZE,
  halfSlideUpTitleFontSize,
  previewHalfSlideUpTitleFontSize
});
export const editHalfSlideUpImgsTitle = halfSlideUpImgsTitle => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_TITLE,
  halfSlideUpImgsTitle
});
export const editHalfSlideUpImgsTitleFontWeight = halfSlideUpImgsTitleFontWeight => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTWEIGHT,
  halfSlideUpImgsTitleFontWeight
});
export const editHalfSlideUpImgsTitleColor = halfSlideUpImgsTitleColor => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_TITLE_COLOR,
  halfSlideUpImgsTitleColor
});
export const editHalfSlideUpImgsTitleFontSize = (
  halfSlideUpImgsTitleFontSize,
  previewHalfSlideUpImgsTitleFontSize
) => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTSIZE,
  halfSlideUpImgsTitleFontSize,
  previewHalfSlideUpImgsTitleFontSize
});
export const editHalfSlideUpImgsSubTitle = halfSlideUpImgsSubTitle => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE,
  halfSlideUpImgsSubTitle
});
export const editHalfSlideUpImgsSubTitleFontWeight = halfSlideUpImgsSubTitleFontWeight => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTWEIGHT,
  halfSlideUpImgsSubTitleFontWeight
});
export const editHalfSlideUpImgsSubTitleColor = halfSlideUpImgsSubTitleColor => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_COLOR,
  halfSlideUpImgsSubTitleColor
});
export const editHalfSlideUpImgsSubTitleFontSize = (
  halfSlideUpImgsSubTitleFontSize,
  previewHalfSlideUpImgsSubTitleFontSize
) => ({
  type: EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTSIZE,
  halfSlideUpImgsSubTitleFontSize,
  previewHalfSlideUpImgsSubTitleFontSize
});

export const editNpsModalDialTitleText = npsModalDialTitleText => ({
  type: NPS_MODAL_DIAL_TITLE_TEXT,
  npsModalDialTitleText
});
export const editNpsModalDialTitleFontSize = npsModalDialTitleFontSize => ({
  type: NPS_MODAL_DIAL_TITLE_FONTSIZE,
  npsModalDialTitleFontSize
});
export const editNpsModalDialTitleFontWeight = npsModalDialTitleFontWeight => ({
  type: NPS_MODAL_DIAL_TITLE_FONTWEIGHT,
  npsModalDialTitleFontWeight
});
export const editNpsModalDialTitleTextColor = npsModalDialTitleTextColor => ({
  type: NPS_MODAL_DIAL_TITLE_TEXT_COLOR,
  npsModalDialTitleTextColor
});

export const editNpsModalDialSubTitleText = npsModalDialSubTitleText => ({
  type: NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT,
  npsModalDialSubTitleText
});
export const editNpsModalDialSubTitleFontSize = npsModalDialSubTitleFontSize => ({
  type: NPS_MODAL_RECT_DIAL_SUBTITLE_FONTSIZE,
  npsModalDialSubTitleFontSize
});
export const editNpsModalDialSubTitleFontWeight = npsModalDialSubTitleFontWeight => ({
  type: NPS_MODAL_RECT_DIAL_SUBTITLE_FONTWEIGHT,
  npsModalDialSubTitleFontWeight
});
export const editNpsModalDialSubTitleTextColor = npsModalDialSubTitleTextColor => ({
  type: NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT_COLOR,
  npsModalDialSubTitleTextColor
});

export const editTitle = value => ({
  type: EDIT_TITLE,
  value
});
export const editSubTitle = value => ({
  type: EDIT_SUB_TITLE,
  value
});
export const editContents = value => ({
  type: EDIT_CONTENTS,
  value
});

export const editText = value => ({
  type: TEXT,
  value
});
export const editPreFontSize = value => ({
  type: PRE_FONT_SIZE,
  value
});
export const editFontSize = value => ({
  type: FONT_SIZE,
  value
});
export const editFontWeight = value => ({
  type: FONT_WEIGHT,
  value
});
export const editColor = value => ({
  type: COLOR,
  value
});
export const editFontFamily = value => ({
  type: FONT_FAMILY,
  value
});
export const editTextAlign = value => ({
  type: TEXT_ALIGN,
  value
});

// 초기상태 정의
const initialState = {
  text1: [
    'Product\nRecommendation\njust for you',
    'Product\nRecommendation\njust for you',
    'Product\nRecommendation\njust for you'
  ],
  subText: [
    'Would you like to see the product you might like?',
    'Would you like to see the product you might like?',
    'Would you like to see the product you might like?'
  ],
  halfTopImageText: ['SALE UP TO 30%', 'SALE UP TO 30%', 'SALE UP TO 30%'],
  halfTopImageSubText: [
    'Get products at a sale price.\nGive away a 10$ coupon for members.',
    'Get products at a sale price.\nGive away a 10$ coupon for members.',
    'Get products at a sale price.\nGive away a 10$ coupon for members.'
  ],
  modalPagingTitle: [
    'Weekly Top Seller 1',
    'Weekly Top Seller 2',
    'Weekly Top Seller 3'
  ],
  modalSlickTitle: [
    'Increase the efficiency\nof your work.',
    'Our Recommendation',
    'Automatic content\nrecommendation'
  ],
  modalSlickSubTitle: [
    'Let’s start now',
    'Start IAM : Recommend,\nand FEEL comfortable.',
    'Selected contents are based on data.'
  ],
  modalTopImageText: [
    "Let's do it together!\nThink Differently",
    "Let's do it together!\nWe can protect it :)",
    "Let's do it together!\nThink Green"
  ],
  singleModalTopText: "Let's do it together!\nThink Green, Zero-Waist",
  fullDualTitle: 'SPECIAL PRICE\nOnly for you',
  fullDualSubTitle: 'Tap the more exciting content for you!',
  fullDualContent1: 'SEASONAL SALE UP TO 70%',
  fullDualContent2: '2021 F/W ACCESSORIES',
  fullDualSubContent1: '11.13 ~ 12.31',
  fullDualSubContent2: 'Get $10 Free Coupon Code',
  fullSurveyTitle: 'Hi there,\nWhat kind of work\nare you doing?',
  fullSurveySubTitle:
    'Thank you for using IAM.\nYour answer will be very helpful.',
  fullDualTitleColor: '#000000',
  fullDualSubTitleColor: '#000000',
  fullDualContent1Color: '#000000',
  fullDualContent2Color: '#000000',
  fullDualTitleFontSize: 25,
  previewFullDualTitleFontSize: 17,
  fullDualSubTitleFontSize: 13,
  previewFullDualSubTitleFontSize: 10,
  fullDualContent1FontSize: 17,
  previewFullDualContent1FontSize: 12,
  fullDualContent2FontSize: 17,
  previewFullDualContent2FontSize: 12,
  fullDualTitleFontWeight: 600,
  fullDualSubTitleFontWeight: 400,
  fullDualContent1FontWeight: 600,
  fullDualContent2FontWeight: 600,
  fontSize1: 29,
  yearFontSize: 20,
  titleFontSize: 58,
  halfTopFontSize: 24,
  subFontSize: 15,
  fontWeight1: 700,
  subFontWeight: 400,
  textColor: '#000000',
  subTextColor: '#000000',
  titleYear: '2021',
  titleText: 'TIMESALE',
  titleFontWeight: 700,
  yearFontWeight: 700,
  titleTextColor: '#ffffff',
  yearTextColor: '#ffffff',
  subTitleColor: '#ffffff',
  subTitle1: 'UP TO 70% OFF! Limited Time ONLY',
  subTitleFontWeight: 700,
  subTitleFontSize: 15,
  countdownTimerText: 'TIME LEFT ON SALE',
  timerFontWeight: 700,
  countdownTimerColor: '#ffffff',
  halfTopFontWeight: 700,
  halfTopTextColor: '#000000',
  previewTitleFontSize: 38,
  previewYearFontSize: 13,
  previewSubTitleFontSize: 1,
  previewFontSize: 19,
  previewSubFontSize: 1,
  previewHalfTopFontSize: 16,
  halfTopSubFontSize: 15,
  previewHalfTopSubFontSize: 1,
  modalPagingTextColor: '#ffffff',
  modalPagingTextFontWeight: 600,
  modalPagingFontSize: 25,
  previewModalPagingFontSize: 17,
  halfTopSubFontColor: '#545454',
  halfTopSubFontWeight: 400,
  modalPagingTimerText: 'TIME LEFT',
  modalPagingTimerColor: '#ffffff',
  modalPagingTimerFontWeight: 600,
  modalSlickTitleColor: '#000000',
  modalSlickSubTitleColor: '#000000',
  modalSlickTitleFontWeight: 600,
  modalSlickSubTitleFontWeight: 400,
  modalSlickTitleFontSize: 18,
  previewModalSlickTitleFontSize: 13,
  modalSlickSubTitleFontSize: 13,
  previewModalSlickSubTitleFontSize: 10,
  fullSurveyTitleColor: '#000000',
  fullSurveySubTitleColor: '#696969',
  fullSurveyTitleFontWeight: 700,
  fullSurveySubTitleFontWeight: 400,
  fullSurveyTitleFontSize: 25,
  previewFullSurveyTitleFontSize: 18,
  fullSurveySubTitleFontSize: 14,
  previewFullSurveySubTitleFontSize: 10,
  modalTopImageTextFontWeight: 600,
  modalTopImageTextColor: '#000000',
  modalTopImageTextFontSize: 22,
  previewModalTopImageTextFontSize: 18,
  singleModalTopTextFontWeight: 600,
  singleModalTopTextColor: '#000000',
  singleModalTopTextFontSize: 22,
  previewSingleModalTopTextFontSize: 18,
  countdownClosing: '종료되었습니다.',
  countdownClosingFontWeight: 700,
  countdownClosingFontColor: '#FFFFFF',
  fullCountDownClosingFontSize: 32,
  previewFullCountDownClosingFontSize: 20,
  halfSlideUpTitle: 'SHOP JUST IN\n#PARTY-LOOK',
  halfSlideUpTitleFontWeight: 600,
  halfSlideUpTitleColor: '#FFFFFF',
  halfSlideUpTitleFontSize: 29,
  previewHalfSlideUpTitleFontSize: 24,
  halfSlideUpSubTitle: 'Ready for NEW YEAR:D',
  halfSlideUpSubTitleFontWeight: 400,
  halfSlideUpSubTitleColor: '#FFFFFF',
  halfSlideUpSubTitleFontSize: 15,
  previewHalfSlideUpSubTitleFontSize: 12,
  halfSlideUpImgsTitle: [
    'Best #Pizza place\naround you!',
    'Best #Taco place\naround you!',
    'Best #Noodle place\naround you!'
  ],
  halfSlideUpImgsTitleFontWeight: 600,
  halfSlideUpImgsTitleColor: '#FFFFFF',
  halfSlideUpImgsTitleFontSize: 29,
  previewHalfSlideUpImgsTitleFontSize: 24,
  halfSlideUpImgsSubTitle: [
    'STAY AT HOME EVENT',
    'STAY AT HOME EVENT',
    'STAY AT HOME EVENT'
  ],
  halfSlideUpImgsSubTitleFontWeight: 400,
  halfSlideUpImgsSubTitleColor: '#FFFFFF',
  halfSlideUpImgsSubTitleFontSize: 15,
  previewHalfSlideUpImgsSubTitleFontSize: 12,

  // npsModalDial
  npsModalDialTitleText: 'Tell us what you think',
  npsModalDialTitleFontSize: 18,
  npsModalDialTitleFontWeight: 600,
  npsModalDialTitleTextColor: '#000000',

  npsModalDialSubTitleText: 'What is your score about our service?',
  npsModalDialSubTitleFontSize: 10,
  npsModalDialSubTitleFontWeight: 400,
  npsModalDialSubTitleTextColor: '#696969',

  // title: {},
  // subTitle: {},

  text: {},
  preFontSize: {},
  fontSize: {},
  fontWeight: {},
  color: {},
  fontFamily: {},
  textAlign: {}

  // title
  // subTitle
  // contents: []
};

// 리듀서 작성
export default function editTextReducer(state = initialState, action) {
  switch (action.type) {
    case EDIT_TEXT_RESET:
      return initialState;
    case EDIT_TITLE1:
      return {
        ...state,
        text: action.text
      };
    case EDIT_FULL_COUNTDOWN_TITLE:
      return {
        ...state,
        titleText: action.titleText
      };
    case EDIT_SUBTITLE1:
      return {
        ...state,
        subText: action.subText
      };
    case EDIT_FULL_COUNTDOWN_SUBTITLE:
      return {
        ...state,
        subTitle: action.subTitle
      };
    case EDIT_FONTSIZE1:
      return {
        ...state,
        fontSize: action.fontSize,
        previewFontSize: action.previewFontSize
      };
    case EDIT_SUBFONTSIZE:
      return {
        ...state,
        subFontSize: action.subFontSize,
        previewSubFontSize: action.previewSubFontSize,
        subTitleFontSize: action.subTitleFontSize,
        previewSubTitleFontSize: action.previewSubTitleFontSize
      };
    case EDIT_FONTWEIGHT1:
      return {
        ...state,
        fontWeight: action.fontWeight,
        titleFontWeight: action.titleFontWeight,
        yearFontWeight: action.yearFontWeight
      };
    case EDIT_SUBFONTWEIGHT:
      return {
        ...state,
        subFontWeight: action.subFontWeight,
        subTitleFontWeight: action.subTitleFontWeight
      };
    case EDIT_TEXTCOLOR:
      return {
        ...state,
        textColor: action.textColor,
        subTitleColor: action.fullCountdownSubTitleColor
      };
    case EDIT_FULLCOUNTDOWN_TEXTCOLOR:
      return {
        ...state,
        titleTextColor: action.fullCountdownTextColor,
        yearTextColor: action.fullCountdownTextColor
      };
    case EDIT_SUBTEXTCOLOR:
      return {
        ...state,
        subTextColor: action.subTextColor
      };
    case EDIT_YEAR:
      return {
        ...state,
        titleYear: action.titleYear
      };
    case EDIT_COUNTDOWN_TIMER_TEXT:
      return {
        ...state,
        countdownTimerText: action.countdownTimerText
      };
    case EDIT_COUNTDOWN_TIMER_FONTWEIGHT:
      return {
        ...state,
        timerFontWeight: action.timerFontWeight
      };
    case EDIT_TIMER_COLOR:
      return {
        ...state,
        countdownTimerColor: action.countdownTimerColor
      };
    case EDIT_HALF_TOP_FONTSIZE:
      return {
        ...state,
        halfTopFontSize: action.halfTopFontSize,
        previewHalfTopFontSize: action.previewHalfTopFontSize
      };
    case EDIT_HALF_TOP_FONTWEIGHT:
      return {
        ...state,
        halfTopFontWeight: action.halfTopFontWeight
      };
    case EDIT_HALF_TOP_TITLE:
      return {
        ...state,
        halfTopImageText: action.halfTopImageText
      };
    case EDIT_HALF_TOP_TEXTCOLOR:
      return {
        ...state,
        halfTopTextColor: action.halfTopTextColor
      };
    case EDIT_FULLCOUNTDOWN_TITLE_FONTSIZE:
      return {
        ...state,
        yearFontSize: action.yearFontSize,
        titleFontSize: action.titleFontSize,
        previewYearFontSize: action.previewYearFontSize,
        previewTitleFontSize: action.previewTitleFontSize
      };
    case EDIT_HALF_TOP_SUB_FONTSIZE:
      return {
        ...state,
        halfTopSubFontSize: action.halfTopSubFontSize,
        previewHalfTopSubFontSize: action.previewHalfTopSubFontSize
      };
    case EDIT_MODAL_TITLE:
      return {
        ...state,
        modalPagingTitle: action.modalPagingTitle
      };
    case EDIT_MODAL_TEXT_COLOR:
      return {
        ...state,
        modalPagingTextColor: action.modalPagingTextColor
      };
    case EDIT_MODAL_FONT_WEIGHT:
      return {
        ...state,
        modalPagingTextFontWeight: action.modalPagingTextFontWeight
      };
    case EDIT_MODAL_FONT_SIZE:
      return {
        ...state,
        modalPagingFontSize: action.modalPagingFontSize,
        previewModalPagingFontSize: action.previewModalPagingFontSize
      };
    case EDIT_HALF_TOP_SUB_TITLE:
      return {
        ...state,
        halfTopImageSubText: action.halfTopImageSubText
      };
    case EDIT_HALF_TOP_SUB_FONT_COLOR:
      return {
        ...state,
        halfTopSubFontColor: action.halfTopSubFontColor
      };
    case EDIT_HALF_TOP_SUB_FONT_WEIGHT:
      return {
        ...state,
        halfTopSubFontWeight: action.halfTopSubFontWeight
      };
    case EDIT_MODAL_PAGING_TIMER_TEXT:
      return {
        ...state,
        modalPagingTimerText: action.modalPagingTimerText
      };
    case EDIT_MODAL_PAGING_TIMER_COLOR:
      return {
        ...state,
        modalPagingTimerColor: action.modalPagingTimerColor
      };
    case EDIT_MODAL_PAGING_TIMER_FONT_WEIGHT:
      return {
        ...state,
        modalPagingTimerFontWeight: action.modalPagingTimerFontWeight
      };
    case EDIT_FULL_DUAL_TITLE:
      return {
        ...state,
        fullDualTitle: action.fullDualTitle
      };
    case EDIT_FULL_DUAL_SUBTITLE:
      return {
        ...state,
        fullDualSubTitle: action.fullDualSubTitle
      };
    case EDIT_FULL_DUAL_CONTENT1:
      return {
        ...state,
        fullDualContent1: action.fullDualContent1
      };
    case EDIT_FULL_DUAL_CONTENT2:
      return {
        ...state,
        fullDualContent2: action.fullDualContent2
      };
    case EDIT_FULL_DUAL_SUBCONTENT1:
      return {
        ...state,
        fullDualSubContent1: action.fullDualSubContent1
      };
    case EDIT_FULL_DUAL_SUBCONTENT2:
      return {
        ...state,
        fullDualSubContent2: action.fullDualSubContent2
      };
    case EDIT_FULL_DUAL_TITLE_COLOR:
      return {
        ...state,
        fullDualTitleColor: action.fullDualTitleColor
      };
    case EDIT_FULL_DUAL_SUBTITLE_COLOR:
      return {
        ...state,
        fullDualSubTitleColor: action.fullDualSubTitleColor
      };
    case EDIT_FULL_DUAL_CONTENT1_COLOR:
      return {
        ...state,
        fullDualContent1Color: action.fullDualContent1Color
      };
    case EDIT_FULL_DUAL_CONTENT2_COLOR:
      return {
        ...state,
        fullDualContent2Color: action.fullDualContent2Color
      };
    case EDIT_FULL_DUAL_TITLE_FONTSIZE:
      return {
        ...state,
        fullDualTitleFontSize: action.fullDualTitleFontSize,
        previewFullDualTitleFontSize: action.previewFullDualTitleFontSize
      };
    case EDIT_FULL_DUAL_SUBTITLE_FONTSIZE:
      return {
        ...state,
        fullDualSubTitleFontSize: action.fullDualSubTitleFontSize,
        previewFullDualSubTitleFontSize: action.previewFullDualSubTitleFontSize
      };
    case EDIT_FULL_DUAL_CONTENT1_FONTSIZE:
      return {
        ...state,
        fullDualContent1FontSize: action.fullDualContent1FontSize,
        previewFullDualContent1FontSize: action.previewFullDualContent1FontSize
      };
    case EDIT_FULL_DUAL_CONTENT2_FONTSIZE:
      return {
        ...state,
        fullDualContent2FontSize: action.fullDualContent2FontSize,
        previewFullDualContent2FontSize: action.previewFullDualContent2FontSize
      };
    case EDIT_FULL_DUAL_TITLE_FONT_WEIGHT:
      return {
        ...state,
        fullDualTitleFontWeight: action.fullDualTitleFontWeight
      };
    case EDIT_FULL_DUAL_SUBTITLE_FONT_WEIGHT:
      return {
        ...state,
        fullDualSubTitleFontWeight: action.fullDualSubTitleFontWeight
      };
    case EDIT_FULL_DUAL_CONTENT1_FONT_WEIGHT:
      return {
        ...state,
        fullDualContent1FontWeight: action.fullDualContent1FontWeight
      };
    case EDIT_FULL_DUAL_CONTENT2_FONT_WEIGHT:
      return {
        ...state,
        fullDualContent2FontWeight: action.fullDualContent2FontWeight
      };
    case EDIT_MODAL_SLICK_TITLE:
      return {
        ...state,
        modalSlickTitle: action.modalSlickTitle
      };
    case EDIT_MODAL_SLICK_SUBTITLE:
      return {
        ...state,
        modalSlickSubTitle: action.modalSlickSubTitle
      };
    case EDIT_MODAL_SLICK_TITLE_COLOR:
      return {
        ...state,
        modalSlickTitleColor: action.modalSlickTitleColor
      };
    case EDIT_MODAL_SLICK_SUBTITLE_COLOR:
      return {
        ...state,
        modalSlickSubTitleColor: action.modalSlickSubTitleColor
      };
    case EDIT_MODAL_SLICK_TITLE_FONT_WEIGHT:
      return {
        ...state,
        modalSlickTitleFontWeight: action.modalSlickTitleFontWeight
      };
    case EDIT_MODAL_SLICK_SUBTITLE_FONT_WEIGHT:
      return {
        ...state,
        modalSlickSubTitleFontWeight: action.modalSlickSubTitleFontWeight
      };
    case EDIT_MODAL_SLICK_TITLE_FONTSIZE:
      return {
        ...state,
        modalSlickTitleFontSize: action.modalSlickTitleFontSize,
        previewModalSlickTitleFontSize: action.previewModalSlickTitleFontSize
      };
    case EDIT_MODAL_SLICK_SUBTITLE_FONTSIZE:
      return {
        ...state,
        modalSlickSubTitleFontSize: action.modalSlickSubTitleFontSize,
        previewModalSlickSubTitleFontSize:
          action.previewModalSlickSubTitleFontSize
      };
    case EDIT_FULL_SURVEY_TITLE:
      return {
        ...state,
        fullSurveyTitle: action.fullSurveyTitle
      };
    case EDIT_FULL_SURVEY_SUBTITLE:
      return {
        ...state,
        fullSurveySubTitle: action.fullSurveySubTitle
      };
    case EDIT_FULL_SURVEY_TITLE_COLOR:
      return {
        ...state,
        fullSurveyTitleColor: action.fullSurveyTitleColor
      };
    case EDIT_FULL_SURVEY_SUBTITLE_COLOR:
      return {
        ...state,
        fullSurveySubTitleColor: action.fullSurveySubTitleColor
      };
    case EDIT_FULL_SURVEY_TITLE_FONT_WEIGHT:
      return {
        ...state,
        fullSurveyTitleFontWeight: action.fullSurveyTitleFontWeight
      };
    case EDIT_FULL_SURVEY_SUBTITLE_FONT_WEIGHT:
      return {
        ...state,
        fullSurveySubTitleFontWeight: action.fullSurveySubTitleFontWeight
      };
    case EDIT_FULL_SURVEY_TITLE_FONTSIZE:
      return {
        ...state,
        fullSurveyTitleFontSize: action.fullSurveyTitleFontSize,
        previewFullSurveyTitleFontSize: action.previewFullSurveyTitleFontSize
      };
    case EDIT_FULL_SURVEY_SUBTITLE_FONTSIZE:
      return {
        ...state,
        fullSurveySubTitleFontSize: action.fullSurveySubTitleFontSize,
        previewFullSurveySubTitleFontSize:
          action.previewFullSurveySubTitleFontSize
      };
    case EDIT_MODAL_TOP_TITLE:
      return {
        ...state,
        modalTopImageText: action.modalTopImageText
      };
    case EDIT_MODAL_TOP_TITLE_FONTWEIGHT:
      return {
        ...state,
        modalTopImageTextFontWeight: action.modalTopImageTextFontWeight
      };
    case EDIT_MODAL_TOP_TITLE_COLOR:
      return {
        ...state,
        modalTopImageTextColor: action.modalTopImageTextColor
      };
    case EDIT_MODAL_TOP_TITLE_FONTSIZE:
      return {
        ...state,
        previewModalTopImageTextFontSize:
          action.previewModalTopImageTextFontSize,
        modalTopImageTextFontSize: action.modalTopImageTextFontSize
      };
    case EDIT_SINGLE_MODAL_TOP_TITLE:
      return {
        ...state,
        singleModalTopText: action.singleModalTopText
      };
    case EDIT_SINGLE_MODAL_TOP_TITLE_FONTWEIGHT:
      return {
        ...state,
        singleModalTopTextFontWeight: action.singleModalTopTextFontWeight
      };
    case EDIT_SINGLE_MODAL_TOP_TITLE_COLOR:
      return {
        ...state,
        singleModalTopTextColor: action.singleModalTopTextColor
      };
    case EDIT_SINGLE_MODAL_TOP_TITLE_FONTSIZE:
      return {
        ...state,
        previewSingleModalTopTextFontSize:
          action.previewSingleModalTopTextFontSize,
        singleModalTopTextFontSize: action.singleModalTopTextFontSize
      };
    case EDIT_FULL_COUNTDOWN_CLOSING:
      return {
        ...state,
        countdownClosing: action.countdownClosing
      };
    case EDIT_FULL_COUNTDOWN_CLOSING_FONTWEIGHT:
      return {
        ...state,
        countdownClosingFontWeight: action.countdownClosingFontWeight
      };
    case EDIT_FULL_COUNTDOWN_CLOSING_FONTCOLOR:
      return {
        ...state,
        countdownClosingFontColor: action.countdownClosingFontColor
      };
    case EDIT_FULL_COUNTDOWN_CLOSING_FONTSIZE:
      return {
        ...state,
        previewFullCountDownClosingFontSize:
          action.previewFullCountDownClosingFontSize,
        fullCountDownClosingFontSize: action.fullCountDownClosingFontSize
      };
    case EDIT_HALF_SLIDE_UP_TITLE:
      return {
        ...state,
        halfSlideUpTitle: action.halfSlideUpTitle
      };
    case EDIT_HALF_SLIDE_UP_TITLE_FONTWEIGHT:
      return {
        ...state,
        halfSlideUpTitleFontWeight: action.halfSlideUpTitleFontWeight
      };
    case EDIT_HALF_SLIDE_UP_TITLE_COLOR:
      return {
        ...state,
        halfSlideUpTitleColor: action.halfSlideUpTitleColor
      };
    case EDIT_HALF_SLIDE_UP_TITLE_FONTSIZE:
      return {
        ...state,
        halfSlideUpTitleFontSize: action.halfSlideUpTitleFontSize,
        previewHalfSlideUpTitleFontSize: action.previewHalfSlideUpTitleFontSize
      };
    case EDIT_HALF_SLIDE_UP_SUBTITLE:
      return {
        ...state,
        halfSlideUpSubTitle: action.halfSlideUpSubTitle
      };
    case EDIT_HALF_SLIDE_UP_SUBTITLE_FONTWEIGHT:
      return {
        ...state,
        halfSlideUpSubTitleFontWeight: action.halfSlideUpSubTitleFontWeight
      };
    case EDIT_HALF_SLIDE_UP_SUBTITLE_COLOR:
      return {
        ...state,
        halfSlideUpSubTitleColor: action.halfSlideUpSubTitleColor
      };
    case EDIT_HALF_SLIDE_UP_SUBTITLE_FONTSIZE:
      return {
        ...state,
        halfSlideUpSubTitleFontSize: action.halfSlideUpSubTitleFontSize,
        previewHalfSlideUpSubTitleFontSize:
          action.previewHalfSlideUpSubTitleFontSize
      };
    case EDIT_HALF_SLIDE_UP_IMGS_TITLE:
      return {
        ...state,
        halfSlideUpImgsTitle: action.halfSlideUpImgsTitle
      };
    case EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTWEIGHT:
      return {
        ...state,
        halfSlideUpImgsTitleFontWeight: action.halfSlideUpImgsTitleFontWeight
      };
    case EDIT_HALF_SLIDE_UP_IMGS_TITLE_COLOR:
      return {
        ...state,
        halfSlideUpImgsTitleColor: action.halfSlideUpImgsTitleColor
      };
    case EDIT_HALF_SLIDE_UP_IMGS_TITLE_FONTSIZE:
      return {
        ...state,
        halfSlideUpImgsTitleFontSize: action.halfSlideUpImgsTitleFontSize,
        previewHalfSlideUpImgsTitleFontSize:
          action.previewHalfSlideUpImgsTitleFontSize
      };
    case EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE:
      return {
        ...state,
        halfSlideUpImgsSubTitle: action.halfSlideUpImgsSubTitle
      };
    case EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTWEIGHT:
      return {
        ...state,
        halfSlideUpImgsSubTitleFontWeight:
          action.halfSlideUpImgsSubTitleFontWeight
      };
    case EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_COLOR:
      return {
        ...state,
        halfSlideUpImgsSubTitleColor: action.halfSlideUpImgsSubTitleColor
      };
    case EDIT_HALF_SLIDE_UP_IMGS_SUBTITLE_FONTSIZE:
      return {
        ...state,
        halfSlideUpImgsSubTitleFontSize: action.halfSlideUpImgsSubTitleFontSize,
        previewHalfSlideUpImgsSubTitleFontSize:
          action.previewHalfSlideUpImgsSubTitleFontSize
      };

    case NPS_MODAL_DIAL_TITLE_TEXT:
      return {
        ...state,
        npsModalDialTitleText: action.npsModalDialTitleText
      };
    case NPS_MODAL_DIAL_TITLE_FONTSIZE:
      return {
        ...state,
        npsModalDialTitleFontSize: action.npsModalDialTitleFontSize
      };
    case NPS_MODAL_DIAL_TITLE_FONTWEIGHT:
      return {
        ...state,
        npsModalDialTitleWeight: action.npsModalDialTitleWeight
      };
    case NPS_MODAL_DIAL_TITLE_TEXT_COLOR:
      return {
        ...state,
        npsModalDialTitleTextColor: action.npsModalDialTitleTextColor
      };
    case NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT:
      return {
        ...state,
        npsModalDialSubTitleText: action.npsModalDialSubTitleText
      };
    case NPS_MODAL_RECT_DIAL_SUBTITLE_FONTSIZE:
      return {
        ...state,
        npsModalDialSubTitleFontSize: action.npsModalDialSubTitleFontSize
      };
    case NPS_MODAL_RECT_DIAL_SUBTITLE_FONTWEIGHT:
      return {
        ...state,
        npsModalDialSubTitleFontWeight: action.npsModalDialSubTitleFontWeight
      };
    case NPS_MODAL_RECT_DIAL_SUBTITLE_TEXT_COLOR:
      return {
        ...state,
        npsModalDialSubTitleTextColor: action.npsModalDialSubTitleTextColor
      };

    case EDIT_TITLE:
      return {
        ...state,
        title: action.value
      };
    case EDIT_SUB_TITLE:
      return {
        ...state,
        subTitle: action.value
      };
    case EDIT_CONTENTS:
      return {
        ...state,
        contents: action.value
      };

    case TEXT:
      return {
        ...state,
        text: action.value
      };
    case PRE_FONT_SIZE:
      return {
        ...state,
        preFontSize: action.value
      };
    case FONT_SIZE:
      return {
        ...state,
        fontSize: action.value
      };
    case FONT_WEIGHT:
      return {
        ...state,
        fontWeight: action.value
      };
    case COLOR:
      return {
        ...state,
        color: action.value
      };
    case FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.value
      };
    case TEXT_ALIGN:
      return {
        ...state,
        textAlign: action.value
      };
    default:
      return state;
  }
}
